declare global {
  interface Window {
    __MSW_ENABLED__?: boolean;
    __MSW_READY__?: boolean;
    __MSW_START_PROMISE__?: Promise<void>;
  }
}

const parseFlag = (value?: string | null) => {
  if (!value) return false;
  const normalized = value.toLowerCase();
  return normalized === 'true' || normalized === '1';
};

let fallbackEnabled = parseFlag(process.env.NEXT_PUBLIC_ENABLE_MSW);
let fallbackStartPromise: Promise<void> | null = null;

export const readMswEnvFlag = () =>
  parseFlag(process.env.NEXT_PUBLIC_ENABLE_MSW);

export const shouldLogMsw = () => process.env.NODE_ENV === 'development';

export const setMswEnabled = (enabled: boolean) => {
  if (typeof window !== 'undefined') {
    window.__MSW_ENABLED__ = enabled;
  } else {
    fallbackEnabled = enabled;
  }
};

export const isMswEnabled = () => {
  if (typeof window !== 'undefined') {
    return Boolean(window.__MSW_ENABLED__);
  }
  return fallbackEnabled;
};

export const setMswStartPromise = (promise: Promise<void> | null) => {
  if (typeof window !== 'undefined') {
    window.__MSW_START_PROMISE__ = promise ?? undefined;
  }
  fallbackStartPromise = promise;
};

export const markMswReady = () => {
  if (typeof window !== 'undefined') {
    window.__MSW_READY__ = true;
  }
};

export const resetMswReady = () => {
  if (typeof window !== 'undefined') {
    delete window.__MSW_READY__;
  }
  fallbackStartPromise = null;
};

export const awaitMswReady = async () => {
  if (!isMswEnabled()) {
    return;
  }

  const promise =
    (typeof window !== 'undefined'
      ? window.__MSW_START_PROMISE__
      : fallbackStartPromise) ?? null;

  if (!promise) {
    return;
  }

  try {
    await promise;
  } catch (error) {
    console.error('[MSW] Failed to initialize before request', error);
  }
};
